<template>
  <h2>Nexus RH Dashboard</h2>
  <v-row 
    class="my-8 align-stretch"
  >
    <v-col
      v-for="(cardInfo, index) in cards"
      :cols="cardInfo?.cols ?? '12'"
      :xxl="cardInfo?.xxl ?? undefined"
      :xl="cardInfo?.xl ?? undefined"
      :lg="cardInfo?.lg ?? undefined"
      :md="cardInfo?.md ?? '4'"
      :sm="cardInfo?.sm ?? undefined"
      :xs="cardInfo?.xs ?? undefined"
    >
      <v-card
        :elevation="cardInfo?.elevation ?? '6'"
        :color="cardInfo?.color ?? 'primary'"
        :class="cardInfo?.cssCardClass ?? 'h-100'"
        rounded="lg"
      >
        <v-card-title
          :class="cardInfo?.cssTitleClass ?? ''"
        >
          {{ cardInfo.title }}
        </v-card-title>
        <v-card-text
          :class="cardInfo?.cssTextClass ?? 'd-flex justify-end'"
        >
          <v-icon v-if="cardInfo.isLoading && first_load">mdi-loading mdi-spin</v-icon>
          <div v-else>
            {{ cardInfo.text }}
          </div>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
  <!-- <v-row class="mt-4">
    <v-col cols="12" md="6">
      <v-skeleton-loader type="card"></v-skeleton-loader>
    </v-col>
    <v-col cols="12" md="6">
      <v-skeleton-loader type="card"></v-skeleton-loader>
    </v-col>
    <v-col cols="12">
      <v-skeleton-loader
        
        :type="[
          'heading', 
          'table-row-divider@5', 
          'actions'
        ]"
      ></v-skeleton-loader>
    </v-col>
  </v-row> -->
       
</template>

<script setup>
import { computed, onMounted, reactive, ref } from 'vue';
import DepartmentMembershipRequest from '../api/departments/membership-requests/DepartmentMembershipRequests';


const first_load = ref(true);
const fetchingCounts = ref(false)
const pendingRequestsAtInitialDepartment = ref(0);
const pendingRequestsAtFinalDepartment = ref(0);
const approvedRequestsAtInitialDepartment = ref(0);
const approvedRequestsAtFinalDepartment = ref(0);
const requestsInPastWeek = ref(0);


const cards = computed(() => [
  {
    title: "Pedidos por Aprovar",
    isLoading: fetchingCounts.value,
    text: `${pendingRequestsAtInitialDepartment.value} CC initical | ${pendingRequestsAtFinalDepartment.value} CC final`,
  },
  {
    title: "Aprovados",
    isLoading: fetchingCounts.value,
    text: `${approvedRequestsAtInitialDepartment.value} CC initical | ${approvedRequestsAtFinalDepartment.value} CC final`,
  },
  {
    title: "Pedidos Semanais",
    isLoading: fetchingCounts.value,
    text: `${requestsInPastWeek.value}`,
  },
])

onMounted( () => {
  fillBaseData();
});

async function fillBaseData() {
  
  fetchingCounts.value = true;
  DepartmentMembershipRequest.stats()
    .then((response) => {
      const counts = response.data || {};

      pendingRequestsAtInitialDepartment.value = counts?.can_approve_initial_department || 0;
      pendingRequestsAtFinalDepartment.value = counts?.can_approve_final_department || 0;
      approvedRequestsAtInitialDepartment.value = counts?.approved_initial_department || 0;
      approvedRequestsAtFinalDepartment.value = counts?.approved_final_department || 0;
      requestsInPastWeek.value = counts?.can_act_past_week || 0;
    })
    .catch((error) => {
      console.error(error);
    })
    .finally(() => {

      fetchingCounts.value = false;
      first_load.value = false;
    });


}
// need to get 
  // count of DepartmentMembershipRequests where created_at = BETWEEN (DATEADD('day', -7, CURRENT_DATE), CURRENT_DATE )
  //  count of DepartmentMembershipRequests currently open the user can resolve
    // initial_department_denied_at IS NULL
    // final_department_denied_at IS NULL
    // final_department_approved_at IS NULL
  // count of DepartmentMembershipRequests the user has approved
    // initial_department_approved_by_user_id == user.id
    // OR final_department_approved_by_user_id == user.id

</script>

<style scoped>

</style>